import React from "react";

/**
 * Aurethion Crown mark — crown atop a hexagonal shield containing an
 * interconnected node network. Silver crown + navy shield + electric-cyan
 * circuit interior. Approved brand mark for Aurethion Crown.
 */
const Crown = ({ className = "w-6 h-6", strokeWidth = 1.25 }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="ac-silver" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FFFFFF" />
        <stop offset="1" stopColor="#8892B0" />
      </linearGradient>
      <linearGradient id="ac-navy" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#1B2A4E" />
        <stop offset="1" stopColor="#0B132B" />
      </linearGradient>
      <radialGradient id="ac-core" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stopColor="#00F5FF" />
        <stop offset="1" stopColor="#0B132B" stopOpacity="0" />
      </radialGradient>
    </defs>

    {/* Crown */}
    <path
      d="M14 22 L20 14 L26 20 L32 10 L38 20 L44 14 L50 22 L48 26 L16 26 Z"
      fill="url(#ac-silver)"
      stroke="#E6E8EC"
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
    <circle cx="20" cy="14" r="1.4" fill="#E6E8EC" />
    <circle cx="44" cy="14" r="1.4" fill="#E6E8EC" />
    <path d="M32 8 L34 10 L32 12 L30 10 Z" fill="#00F5FF" />

    {/* Shield */}
    <path
      d="M18 26 L46 26 L52 32 L46 54 L32 60 L18 54 L12 32 Z"
      fill="url(#ac-navy)"
      stroke="#E6E8EC"
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />

    {/* Interior node network */}
    <g stroke="#00B4DB" strokeWidth="1.1" strokeLinecap="round" fill="none" opacity="0.95">
      <line x1="32" y1="42" x2="24" y2="34" />
      <line x1="32" y1="42" x2="40" y2="34" />
      <line x1="32" y1="42" x2="24" y2="50" />
      <line x1="32" y1="42" x2="40" y2="50" />
      <line x1="32" y1="42" x2="32" y2="32" />
      <line x1="32" y1="42" x2="32" y2="52" />
    </g>
    <circle cx="32" cy="42" r="6" fill="url(#ac-core)" />
    <circle cx="32" cy="42" r="3" fill="none" stroke="#00F5FF" strokeWidth="1.1" />
    <circle cx="32" cy="42" r="1.2" fill="#00F5FF" />

    {[
      [24, 34], [40, 34], [24, 50], [40, 50], [32, 32], [32, 52],
    ].map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r="1.8" fill="#0B132B" stroke="#00B4DB" strokeWidth="1.1" />
    ))}
  </svg>
);

export default Crown;
